import { render, staticRenderFns } from "./PscMonthlyCommittee.vue?vue&type=template&id=7814884e&scoped=true&"
import script from "./PscMonthlyCommittee.vue?vue&type=script&lang=js&"
export * from "./PscMonthlyCommittee.vue?vue&type=script&lang=js&"
import style0 from "./PscMonthlyCommittee.vue?vue&type=style&index=0&id=7814884e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7814884e",
  null
  
)

export default component.exports